<div class="border rounded-1 pt-2 filter-container record-container p-2">
    <div class="d-flex align-items-center mb-3">
        <span class="text-size-title fw-bold me-3">{{'NAVIGATION.MONITORING' | translate}}</span>
        
        <!-- First row: Devices and Sites -->
        <div class="currently d-flex align-items-center ms-3 input-container mb-2">
            <ng-select 
            class="ng-select-width me-2"
            name="devices" 
            [items]="initialDeviceList" 
            bindLabel="serialNumber" 
            bindValue="id" 
            [multiple]="true" 
            [hideSelected]="false" 
            [closeOnSelect]="false" 
            [clearable]="true" 
            placeholder="{{ 'DEVICE.TITLE' | translate }}"
            [(ngModel)]="selectedDeviceIds"
            (change)="onDeviceChange($event)">
          </ng-select>
          
            <ng-select 
            class="ng-select-width me-2"
            name="listeSites" 
            [items]="listeSites" 
            bindLabel="nom" 
            bindValue="siteId" 
            [hideSelected]="false" 
            [closeOnSelect]="true" 
            [clearable]="true" 
            placeholder="Sites"
            [ngModel]="selectedSiteId"
            (change)="onSiteChange($event)">
          </ng-select>
        </div>
    </div>
    
    <!-- Second row: Time Range, Date and Time filters -->
    <div class="d-flex align-items-center mb-3 ms-3">
        <div class="d-flex align-items-center input-container">

          <ng-select 
            class="ng-select-width me-2"
            name="timeRange" 
            [items]="timeRangeOptions" 
            bindLabel="label" 
            bindValue="value" 
            [hideSelected]="false" 
            [closeOnSelect]="true" 
            [clearable]="false" 
            placeholder="Time Range"
            [(ngModel)]="selectedTimeRange"
            (ngModelChange)="onTimeRangeChange($event)">
          </ng-select>
            <input class="input-field me-2" type="date" placeholder="{{ 'PLACEHOLDERS.DATE_FORMAT' | translate }}"
            (change)="onDateChange($event)" [(ngModel)]="selectedDateString" [max]="maxDate" 
            title="Manual date"/>
            <div class="time-input-wrapper me-2" *ngIf="selectedTimeRange === 'custom'">
                            <input
                                class="input-field time-input"
                                type="time"
                                step="60"
                                [ngModel]="startTime?.substring(0,5)"
                                (change)="onStartTimeChange($event)"
                                title="Heure de début"
                            />
            </div>

            <div class="time-input-wrapper me-2" *ngIf="selectedTimeRange === 'custom'">
                            <input
                                class="input-field time-input"
                                type="time"
                                step="60"
                                [ngModel]="endTime?.substring(0,5)"
                                (change)="onEndTimeChange($event)"
                                title="Heure de fin"
                            />
            </div>
        </div>
    </div>
    <div class="divider"></div> 
    <div class="parent-container" #scrollContainer>
    <div class="settings-list border-style" >
    <ng-container *ngFor="let device of devices; index as i; trackBy: trackById" class="chart">
        <div class="row-container" [ngClass]="{
        'detailled': isDetailsVisible[i],
        'channels-visible': isChannelsVisible[i],
        'red-alarm-reached': redAlarmReachedDevices.includes(device.deviceId),
        'orange-alarm-reached': !redAlarmReachedDevices.includes(device.deviceId) && orangeAlarmReachedDevices.includes(device.deviceId),
        'yellow-alarm-reached': !redAlarmReachedDevices.includes(device.deviceId) && !orangeAlarmReachedDevices.includes(device.deviceId) && yellowAlarmReachedDevices.includes(device.deviceId)
        }" #rowElement>
            <div class="row pe-0 mb-3" >
                <div class="col-2 d-flex flex-column justify-content-center align-items-start">
                    <div class="d-flex align-items-center justify-content-start">
                        <img src="./icon/device.svg" class="me-2" />
                        <span class="text-size-14 fw-bold">{{device.deviceName}}</span>
                    </div>
                    <button class="mt-2 primary-button d-center" (click)="viewDeviceDetails(device.deviceName)">
                        <span class="text-size">{{'MONITORING.VIEW_DEVICE' | translate}}</span>
                    </button>
                </div>
                <div class="table-column mail border-left-line">
                    <div class="text-muted">{{ 'MONITORING.MODEL' | translate }}</div>
                    <div class="default-text" title="{{ device?.modelName }}"></div>
                </div>
                <div class="table-column company">
                    <div class="text-muted">{{ 'DEVICE.SITE' | translate }}</div>
                    <div>{{ getSiteName(device.siteId)}}</div>
                </div>
                <div class="table-column organization">
                    <div class="text-muted">{{ 'REPORT.MEASUREMENT_POINTS' | translate }}</div>
                    <div>{{ device.controlPointName }}</div>
                </div>
                <div class="table-column language">
                    <div class="text-muted">{{ 'VIBRATION.NOTES' | translate }}</div>
                    <div *ngFor="let note of device.notes; ">
                    <div>{{ note  }}</div>
                    </div>  
                </div>

                <div class="table-column actions">
                    <button class="collapse-toggle ms-auto"
                    (click)="toggleDetails(i); $event.stopPropagation()">
                    <img [src]="isDetailsVisible[i] ? './icon/arraw-up.svg' : './icon/arraw-down.svg'"
                    class="arrow-icon" />
                </button>
                </div>
            </div>
            <div class="divider mb-1" [hidden]="!isDetailsVisible[i]"></div> 
            <div class="row ms-2 " [hidden]="!isDetailsVisible[i]" style="height: 13rem;">
                <canvas class="canvas-custom-width" attr.id="canvas-{{i}}" height="500vh"></canvas>
            </div>
            <div class="row ms-2 mt-1 align-items-center show-channels" [hidden]="!isDetailsVisible[i]">
                <div class="col d-flex align-items-center gap-3" style="font-size: 0.8rem; font-weight: 600;">
                    <span>Max Vec Sum: <span >{{ (deviceMaxValues[i]?.maxVecSum | number:'1.3-3') ?? '--' }} mm/s</span></span>
                    <span>Max Channels: <span >{{ (deviceMaxValues[i]?.maxChannels | number:'1.3-3') ?? '--' }} mm/s</span></span>
                    <span>Max Sound: <span >{{ (deviceMaxValues[i]?.maxSound | number:'1.0-0') ?? '--' }} Pa</span></span>
                </div>
                <div class="col-auto">
                    <button class="secondary-button" (click)="toggleChannels(i); $event.stopPropagation()">
                        <img [src]="isChannelsVisible[i] ? './icon/arraw-up.svg' : './icon/arraw-down.svg'"
                        class="arrow-icon me-0" />
                        {{ (isChannelsVisible[i] ? 'MONITORING.HIDE_CHANNELS' : 'MONITORING.SHOW_CHANNELS') | translate }}
                    </button>
                </div>
            </div>
            <div class="row ms-2" [hidden]="!isDetailsVisible[i] || !isChannelsVisible[i]">
                <div class="col-12">
                    <div class="channel-chart-container">
                        <canvas attr.id="canvas-channels-{{i}}" height="300"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    </div>
    </div>
</div>

<template id="dataPointPopupTemplate">
    <div class="popup-timestamp" id="timestamp"></div>
    <div class="popup-row">
        <div class="popup-label">Transversal</div>
        <div class="popup-value">
            <div id="vecSomme"></div>
        </div>
    </div>
    <div class="popup-row">
        <div class="popup-label">PPV Max</div>
        <div class="popup-value">
            <div id="ppvMax"></div>
        </div>
    </div>
    <div class="popup-row">
        <div class="popup-label">{{'RECORD.AIR_OVERPRESSURE' | translate}}</div>
        <div class="popup-value">
            Pa:
            <div id="airOverpressurePa"></div>
            dB(L):
            <div id="airOverpressureDb"></div>
        </div>
    </div>
    <div class="popup-row popup-icon-row">
        <svg-icon src="assets/icons/measurement-point.svg" [svgStyle]="{
            width: '12px',
            height: '12px',
            color: '#FDFDFD'
        }"></svg-icon>
        <div id="measurementPoint" class="fw-bold popup-icon-label"></div>
    </div>
    <div class="popup-row popup-icon-row">
        <svg-icon src="./icon/site.svg" [svgStyle]="{
            width: '12px',
            height: '12px',
            color: '#FDFDFD'
        }"></svg-icon>
    <div id="siteName" class="fw-bold popup-icon-label"></div>
    </div>
    <div class="popup-buttons">
        <button class="secondary-button">{{'MONITORING.CLOSE' | translate}}</button>
        <button class="view-record-btn primary-button" [disabled]="disabled">
            <img src="icon/eye.svg" alt="View" />
            {{'MONITORING.VIEW_RECORD' | translate}}
        </button>
    </div>
</template>
